<template>
  <div class="mainBody">
    <div class="mainCtn">
      <div class="topCtn">
        <div class="label">
          <img src="../../assets/rsTool/标注人员图标.png" height="20" width="20" style="display: inline-block;margin-right: 1px;margin-top: -3px;" />
          我是标注人员
        </div>
      </div>
      <div class="taskCtn">
        <div class="componentsCtn_1">
          <div  class="signUp_content" >
            <!--selectType,1:协同标注，2：标注真核，3：外业核查-->
            <!--协同标注，任务列表-->
            <div v-if="selectType==1&&XTBZ_Stey==1" class="componentCtn-main">
              <div class="searchPanel">
                <div class="txt">
                  任务名称:
                </div>
                <div class="input" style="padding-right: 20px;">
                  <a-input size="large" v-model="InputTaskName"  style="height: 40px;font-size: 14px;" placeholder="请输入任务名称"/>
                </div>
                <div class="txt">
                  任务状态:
                </div>
                <div class="input">
                  <a-select size="large" style="height:40px;width:100%;font-size: 14px" placeholder="请选择任务状态" v-model="InputTaskStatus">
                    <a-select-option value="未开始">
                      未开始
                    </a-select-option>
                    <a-select-option value="进行中">
                      进行中
                    </a-select-option>
                    <a-select-option value="已完成">
                      已完成
                    </a-select-option>
                  </a-select>
                </div>
                <img src="../../assets/userCenter/查找.png" title="搜索" height="40" width="40" style="margin-left: 25px;cursor: pointer;" @click="searchQue"/>
                <img src="../../assets/userCenter/重置.png" title="重置" height="40" width="40" style="margin-left: 25px;cursor: pointer;" @click="reSetQue"/>
              </div>
              <div class="tableCtn" >
                <a-table
                    :columns="tableColumns"
                    :data-source="tableData"
                    :pagination="ipagination"
                    style="font-weight: 700"
                    @change="handleTableChange"

                >
                <span slot="statusTags" slot-scope="status">
                  <a-tag
                      :color="status === '进行中' ? 'green' : status ==='未开始' ? 'blue' : 'volcano'"
                  >
                    {{ status }}
                  </a-tag>
                </span>
                  <span slot="action" slot-scope="text, record">
                  <a
                      @click="intoProject(record)"
                      :disabled="record.taskStatus!='进行中'"
                      :style="record.taskStatus === '进行中' ? startStyle : record.taskStatus ==='未开始' ? noStartStyle : OverStartStyle"
                  >查看</a>
                </span>
                </a-table>
              </div>

            </div>
            <!--协同标注，iframe外接-->
            <div v-if="selectType==1&&XTBZ_Stey==2" :class="XTBZ_FullScreen?'componentCtn-main-fullScreen':'componentCtn-main'" :style="XTBZ_FullScreen?'':'margin-top: 30px;'">
              <div
                  v-if="!XTBZ_FullScreen"
                  @click="XTBZ_FullScreen=true"
                  style="position:absolute;top:-30px;left:0px;height:30px;line-height:30px;width:100px;z-index:100000;cursor:pointer;color:#1f91f5;">
                <img src="../../assets/userCenter/全屏.png" height="32" width="32"/>
                全屏展示
              </div>
              <div
                  v-if="XTBZ_FullScreen"
                  @click="XTBZ_FullScreen=false;XTBZ_Stey =1"
                  style="position:absolute;top:0px;left:0px;height:30px;line-height:30px;width:100px;z-index:100000;cursor:pointer;color:#1f91f5;">
                <!-- <img src="../../assets/userCenter/退出全屏.png" height="32" width="32"/>
                返回列表 -->
                <a-button style="background-color: #0091ff;color:white;top: 13px;left: 10px;">返回列表</a-button>
              </div>
              <iframe class="bash_iframe"  :src=frameUrl :style="XTBZ_FullScreen?'height:100%':'border-radius:16px;margin-bottom:10px;'">

              </iframe>


            </div>

            <!--selectType,1:协同标注，2：标注真核，3：外业核查-->
            <!--标注审核，任务列表-->
            <div v-if="selectType==2&&XTBZ_Stey==1" class="componentCtn-main">
              <div class="searchPanel">
                <div class="txt">
                  任务名称:
                </div>
                <div class="input" style="padding-right: 20px;">
                  <a-input size="large"  v-model="InputTaskName"  style="height: 40px;font-size: 14px;" placeholder="请输入任务名称"/>
                </div>
                <div class="txt">
                  任务状态:
                </div>
                <div class="input">
                  <a-select size="large" style="height:40px;width:100%;font-size: 14px" placeholder="请选择任务状态" v-model="InputTaskStatus">
                    <a-select-option value="未开始">
                      未开始
                    </a-select-option>
                    <a-select-option value="进行中">
                      进行中
                    </a-select-option>
                    <a-select-option value="已完成">
                      已完成
                    </a-select-option>
                  </a-select>
                </div>
                <img src="../../assets/userCenter/查找.png" title="搜索" height="40" width="40" style="margin-left: 25px;cursor: pointer;" @click="searchQue"/>
                <img src="../../assets/userCenter/重置.png" title="重置" height="40" width="40" style="margin-left: 25px;cursor: pointer;" @click="reSetQue"/>
              </div>
              <div class="tableCtn" >
                <a-table
                    :columns="tableColumns"
                    :data-source="tableDataAudit"
                    :pagination="ipaginationAudit"
                    style="font-weight: 700"
                    @change="handleTableChangeAudit"
                >
                <span slot="statusTags" slot-scope="status">
                  <a-tag
                      :color="status === '进行中' ? 'green' : status ==='未开始' ? 'blue' : 'volcano'"
                  >
                    {{ status }}
                  </a-tag>
                </span>
                  <span slot="action" slot-scope="text, record">
                  <a
                      @click="intoProjectAudit(record)"
                      :disabled="record.taskStatus!='进行中'"
                      :style="record.taskStatus === '进行中' ? startStyle : record.taskStatus ==='未开始' ? noStartStyle : OverStartStyle"
                  >查看</a>
                </span>
                </a-table>
              </div>

            </div>
            <!--标注审核，iframe外接-->
            <div v-if="selectType==2&&XTBZ_Stey==2" :class="XTBZ_FullScreen?'componentCtn-main-fullScreen':'componentCtn-main'" :style="XTBZ_FullScreen?'':'margin-top: 30px;'">
              <div
                  v-if="!XTBZ_FullScreen"
                  @click="XTBZ_FullScreen=true"
                  style="position:absolute;top:-30px;left:0px;height:30px;line-height:30px;width:100px;z-index:100000;cursor:pointer;color:#1f91f5;">
                <img src="../../assets/userCenter/全屏.png" height="32" width="32"/>
                全屏展示
              </div>
              <div
                  v-if="XTBZ_FullScreen"
                  @click="XTBZ_FullScreen=false;XTBZ_Stey =1"
                  style="position:absolute;top:0px;left:0px;height:30px;line-height:30px;width:100px;z-index:100000;cursor:pointer;color:#1f91f5;">
                <!-- <img src="../../assets/userCenter/退出全屏.png" height="32" width="32"/>
                返回列表 -->
                <a-button style="background-color: #0091ff;color:white;top: 13px;left: 10px;">返回列表</a-button>
              </div>
              <iframe class="bash_iframe"  :src=frameUrl :style="XTBZ_FullScreen?'height:100%':'border-radius:16px;margin-bottom:10px;'">

              </iframe>


            </div>
            <!--外业核查，iframe外接-->
            <div v-if="selectType==3" class="componentCtn-main">

            </div>
          </div>


          <!--任务详情对话框，我的任务-协同标注-->
          <a-modal v-model="projectDetailDialog"
                   :footer="null"
                   centered
                   width="667">
            <div style="width:667px;height:auto;min-height:200px;" class="detailCtn">
              <table class="table1">
                <tr class="tr1">
                  <td class="td1"  colspan="2" >
                <span class="blod">
                  任务名称:
                </span>
                    12312312312312312312312312312321
                  </td>
                </tr>
                <tr class="tr1">
                  <td class="td1" >
                <span class="blod">
                  矢量来源:
                </span>
                    123
                  </td>
                  <td class="td1">
                <span class="blod">
                  矢量类型:
                </span>
                    123
                  </td>
                  <td class="td1">
                <span class="blod">
                  坐标系:
                </span>
                    123
                  </td>
                </tr>
                <tr class="tr1">
                  <td class="td1" >
                <span class="blod">
                  创建人:
                </span>
                    123
                  </td>
                  <td class="td1">
                <span class="blod">
                  创建时间:
                </span>
                    123
                  </td>
                  <td class="td1">
                <span class="blod">
                  任务状态:
                </span>
                    123
                  </td>
                </tr>
                <tr class="tr1">
                  <td class="td1" colspan="3">
                <span class="blod">
                  任务标签:
                </span>
                    <a-tag
                        :color="'blue'"
                    >
                      123
                    </a-tag>
                  </td>

                </tr>
                <tr class="tr1">
                  <td class="td1" colspan="3">
                <span class="blod">
                  标注人员:
                </span>
                    <a-tag
                        :color="'red'"
                    >
                      123
                    </a-tag>
                  </td>
                </tr>
                <tr class="tr1">
                  <td class="td1" colspan="3">
                <span class="blod">
                  影像服务:
                </span>
                    <a-tag
                        :color="'green'"
                    >
                      123
                    </a-tag>
                  </td>
                </tr>

                <tr class="tr1">
                  <td class="td1" >
                <span class="blod">
                  标注总数:
                </span>
                    <a-tag
                        :color="'blue'"
                    >
                      123
                    </a-tag>
                  </td>
                  <td class="td1">
                <span class="blod">
                  审核通过数量:
                </span>
                    <a-tag
                        :color="'green'"
                    >
                      123
                    </a-tag>
                  </td>
                  <td class="td1">
                <span class="blod">
                  待审核数量:
                </span>
                    <a-tag
                        :color="'red'"
                    >
                      123
                    </a-tag>
                  </td>
                </tr>
              </table>
            </div>
            <template slot="title" style="border:none;">
              <div
                  style="height:40px;line-height: 40px;font-size: 20px;font-weight: 700;border-left:5px solid #0091ff;padding-left: 15px;">
                详情
              </div>
            </template>
          </a-modal>


        </div>

      </div>





    </div>

  </div>
</template>
<script>

export default {
  name:'markerTask',
  components: {

  },
  data(){
    return{
      selectType:1,//1：协同标注，2：标注审核；3.外业核查
      tableColumns:[
        {
          title:'任务名称',
          dataIndex: 'taskName',
          key: 'taskName',
          align:'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          key: 'createTime',
          align:'center'

        },
        {
          title: '任务状态',
          dataIndex: 'taskStatus',
          key: 'taskStatus',
          scopedSlots: { customRender: 'statusTags' },
          align:'center'

        },
        {
          title: '创建人',
          key: 'createByName',
          dataIndex: 'createByName',
          align:'center'
        },
        {
          title: '操作',
          key: 'action',
          scopedSlots: { customRender: 'action' },
          align:'center'

        },
      ],
      tableData:[],
      tableDataAudit:[],
      /* 分页参数 */
      ipagination:{
        current: 1,
        pageSize: 10,
        // pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + "-" + range[1] + " 共" + total + "条"
        },
        showQuickJumper: true,
        // showSizeChanger: true,
        total: 0
      },
      /* 排序参数 */
      isorter:{
        column: 'createTime',
        order: 'desc',
      },
      ipaginationAudit:{
        current: 1,
        pageSize: 10,
        // pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + "-" + range[1] + " 共" + total + "条"
        },
        showQuickJumper: true,
        // showSizeChanger: true,
        total: 0
      },
      projectDetailDialog:false,//任务详情
      XTBZ_Stey:1,//协同标注步骤，1：列表，2：外接
      BZSH_FullScreen:false,//标注审核-我的任务，全屏
      XTBZ_FullScreen:false,//系统标注-我的任务，全屏
      // frameBaseUrl:'https://storedev.jl1.cn/gisworkbench',
      frameBaseUrl:'https://www.jl1mall.com/gisworkbench',
      // frameBaseUrl:'http://10.200.30.19:3000/gisworkbench',

      frameUrl:this.frameBaseUrl + '/analysisTask/SampleLabeling',
      frameUrlOld:this.frameBaseUrl + '/analysisTask/SampleLabeling',

      InputTaskStatus:'',
      InputTaskName:'',
      startStyle:{
        color:'green'
      },
      noStartStyle:{
        color:'LightGrey'
      },
      OverStartStyle:{
        color:'LightGrey'
      }


    }
  },
  methods:{
    searchQue(){
      if(this.selectType == 1){
        this.loadData()
      }else if(this.selectType == 2){
        this.loadDataAudit()
      }
    },
    reSetQue(){
      this.InputTaskStatus = ''
      this.InputTaskName = ''
      this.ipagination.current = 1
      this.ipaginationAudit.current = 1
      if(this.selectType == 1){
        this.loadData()
      }else if(this.selectType == 2){
        this.loadDataAudit()
      }
    },
    selectTypeChange:function () {
      console.log(this.selectType)
      this.InputTaskStatus = ''
      this.InputTaskName = ''
      this.ipagination.current = 1
      this.ipaginationAudit.current = 1
      if(this.selectType == 1){
        this.loadData()
      }else if(this.selectType == 2){
        this.loadDataAudit()
      }
      this.XTBZ_Stey=1;
    },
    //显示我的任务，任务详情（协同标注）
    showProjectDetail:function (data){
      console.log(data)
      this.projectDetailDialog=true;
    },
    //查看任务  协同标注
    intoProject:function (record){
      this.frameUrl = this.frameBaseUrl+`/analysisTask/SampleLabeling?taskId=${record.id}&token=${this.getKey()}`
      this.XTBZ_Stey=2;
      this.XTBZ_FullScreen = true
    },

    //查看任务  标注审核
    intoProjectAudit:function (record){
      console.log(record);
      this.frameUrl = this.frameBaseUrl+`/analysisTask/SampleLabelAudit?taskId=${record.id}&token=${this.getKey()}&project=0`
      this.XTBZ_Stey=2;
      this.XTBZ_FullScreen = true
    },
    getKey() {
      return localStorage.getItem("token");
    },
    handleTableChange(pagination, filters, sorter) {
      //分页、排序、筛选变化时触发
      //TODO 筛选
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
      }
      this.ipagination = pagination;
      this.loadData();
    },
    handleTableChangeAudit(pagination, filters, sorter){
      //分页、排序、筛选变化时触发
      //TODO 筛选
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
      }
      this.ipaginationAudit = pagination;
      this.loadDataAudit();
    },
    loadData(){
      //获取我的任务对应的所有任务列表
      this.axios({
        method: 'get',
        url: '/tiles_back/markTask/queryMarkTaskByUserId',
        headers: {
          Authorization: "Bearer " + this.getKey(),
        },
        params: {
          pageNo:this.ipagination.current,
          pageSize:10,
          taskName:this.InputTaskName,
          taskStatus:this.InputTaskStatus
        }
      }).then((response) => {
        this.tableData = response.data.data.records
        this.ipagination.total = response.data.data.records.length
      })
    },

    loadDataAudit(){
      //获取我的任务对应的所有任务列表
      this.axios({
        method: 'get',
        url: '/tiles_back/markTask/queryMarkAuditTaskByUserId',
        headers: {
          Authorization: "Bearer " + this.getKey(),
        },
        params: {
          pageNo:this.ipaginationAudit.current,
          pageSize:10,
          taskName:this.InputTaskName,
          taskStatus:this.InputTaskStatus
        }
      }).then((response) => {
        this.tableDataAudit = response.data.data.records
        this.ipaginationAudit.total = response.data.data.records.length
      })
    },

  },
  mounted(){
    //获取我的任务对应的所有任务列表
    this.loadData()
    //获取我的任务对应的所有任务列表
    // this.loadDataAudit()
    this.frameUrlOld = this.frameBaseUrl + `/analysisTask/SampleLabelAudit?token=${this.getKey()}&project=0`
  }
}

</script>
<style scoped lang="scss">
.taskCtn{
  width: 100%;
  height:660px;
  margin-top: 20px;
}
.mainBody{
  width: 100%;
  height:100%;
  background-image: url('../../assets/rsTool/选角色背景.png');
  background-size: 100% 100%;
  padding-top: 1px;
}
.mainCtn{
  width: 1520px;
  height:780px;
  margin-right: auto;
  margin-left: auto;
  margin-top: 138px;
  .topCtn{
    display: flex;
    justify-content: space-between;
    width:100%;
    height:50px;
    .label{
      width: 188px;
      height: 40px;
      background: rgba(0,102,204,0.35);
      border-radius: 4px;
      line-height: 40px;
      font-size: 21px;
      font-family: PingFangSC-Semibold, PingFang SC;
      color: #0066CC;
      padding-left: 6px;
    }
  }


}
.detailCtn{
  .table1{
    width: 667px;
    .tr1{
      height:40px;
      line-height: 40px;
      width: 100%;
    }
    .td1{
      width: 200px;
    }
    .blod{
      font-weight: bold;
    }
  }
}
::v-deep .ant-table-thead > tr > th {
  font-weight: 700;
}
.tableCtn{
  width: 100%;
  height:500px;
  padding-right: 20px;
  overflow-y: scroll;
}
.searchPanel {
  width: 100%;
  height:60px;
  position:relative;
  display: flex;
  justify-content: left;
  padding-top: 10px;
  .txt{
    width: 85px;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #000000;
  }
  .input{
    width: 200px;
    height: 40px;
    line-height: 40px;
  }
}
.bash_iframe{
  width:calc(100% - 20px);
}
.signUp_content {
  width: 100%;
  height: 100%;
  overflow-y: auto;

  .componentCtn-main {
    position:relative;
    width: 100%;
    height: auto;
    min-height: 570px;
    display: flex;
    justify-content: left;
    flex-flow: wrap;
  }
  .componentCtn-main-fullScreen{
    position:fixed;
    top:0px;
    left:0px;
    width: 100vw;
    height: 100%;
    z-index: 10000;
  }
}
/*滚动条样式*/
.tableCtn::-webkit-scrollbar {
  width: 4px;
}

.tableCtn::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}

.tableCtn::-webkit-scrollbar-track {
}
/*滚动条样式*/
.signUp_content::-webkit-scrollbar {
  width: 4px;
}

.signUp_content::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}

.signUp_content::-webkit-scrollbar-track {
}

.selectPanel {
  height: 30px;
  line-height: 30px;
  width: 100%;
  position: relative;
}

.top {
  height: 84px;
  line-height: 84px;
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #3A3A3A;
}

.componentsCtn_1 {
  width: 100%;
  min-height: 660px;
  height: auto;
  background: #F5F5F6;
  border-radius: 16px;
  padding-left: 60px;
  padding-right: 60px;
  padding-top: 40px;
}
</style>